import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'react-bootstrap/lib/Carousel';
import Image from 'react-bootstrap/lib/Image';
import FontIcomoonIcon from '../FontIcomoonIcon';

class AdsensePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images,
      indexSelected: 1,
    };
  }

  onPaginationClick = (index) => {
    this.setState({ indexSelected: index });
  };

  onNext = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.state.images.length - 1;

    if (indexSelected >= maxIndex) {
      return this.setState({ indexSelected: 1 });
    }

    this.setState({ indexSelected: indexSelected + 1 });
  };

  onPrevious = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.state.images.length - 1;

    if (indexSelected <= 1) {
      return this.setState({ indexSelected: maxIndex });
    }

    this.setState({ indexSelected: indexSelected - 1 });
  };

  render() {
    const { images, indexSelected } = this.state;
    console.log('imagesssssssssssssss', images);

    return (
      <div className="adsense-preview">
        {images.length === 1 && (
          <div style={{ justifyContent: 'center' }}>
            <Image
              className="img-responsive"
              src={images[0].path}
              responsive
              style={{ maxWidth: '750px' }}
            />
          </div>
        )}
        {images.length > 1 && (
          <div className="adsense-wrapper">
            <div className="adsense-detail">
              <div className="adsense-pagination">
                <div className="text-center" style={{ fontSize: 12 }}>
                  <FontAwesomeIcon
                    style={{
                      width: 16,
                      transform: 'rotate(100deg)',
                    }}
                    icon={faPaperclip}
                  />{' '}
                  {images.length - 1} Files set
                </div>
                {images.map((item, index) => {
                  if (index === 0) return null;
                  return (
                    <div
                      key={index}
                      className="adsense-pagination-item-wrapper"
                      onClick={() => {
                        this.onPaginationClick(index);
                      }}
                    >
                      <div className="adsense-pagination-item">
                        <img className="img-responsive" src={item.thumbnail} />
                      </div>
                      <div className="adsense-pagination-hover">
                        <FontIcomoonIcon icon="icon-search" fixedWidth />
                      </div>
                      {index === indexSelected && (
                        <div className="current-thumbnail-arrow">
                          <FontIcomoonIcon icon="icon-right-arrow" fixedWidth />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="left-icon" onClick={this.onPrevious}>
                <FontIcomoonIcon
                  style={{ transform: 'rotate(180deg)' }}
                  fixedWidth
                  icon="icon-register-arrow-right"
                />
              </div>
              <div className="adsense-container">
                <Carousel
                  activeIndex={indexSelected}
                  direction="next"
                  controls={false}
                >
                  {images.map((item, key) => (
                    <Carousel.Item key={key}>
                      <img
                        width={800}
                        height={400}
                        className="img-responsive"
                        src={`${item.path}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              <div className="right-icon" onClick={this.onNext}>
                <FontIcomoonIcon icon="icon-register-arrow-right" fixedWidth />
              </div>
            </div>
          </div>
        )}
        <style jsx>
          {`
            .adsense-preview .current-thumbnail-arrow {
              top: 47%;
            }

            .adsense-preview .carousel-indicators {
              display: none;
            }

            .adsense-preview .adsense-wrapper {
              display: flex;
              flex-wrap: wrap;
              background-color: #ffffff;
              padding: 15px 10px 15px 50px;
            }
            .adsense-preview .adsense-wrapper .adsense-pagination {
              width: 145px;
            }
            .adsense-preview
              .adsense-wrapper
              .adsense-pagination
              .adsense-pagination-item-wrapper {
              position: relative;
            }
            .adsense-preview
              .adsense-wrapper
              .adsense-pagination
              .adsense-pagination-item-wrapper:hover
              .adsense-pagination-hover {
              opacity: 1;
            }
            .adsense-preview
              .adsense-wrapper
              .adsense-pagination
              .adsense-pagination-hover {
              display: flex;
              opacity: 0;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              -webkit-transition: opacity 0.5s;
              -moz-transition: opacity 0.5s;
              -ms-transition: opacity 0.5s;
              -o-transition: opacity 0.5s;
              transition: opacity 0.5s;
              position: absolute;
              top: 0;
              width: 100%;
              height: 100%;
              color: #fff;
              font-size: 35px;
              cursor: pointer;
              background-color: rgba(29, 29, 29, 0.5);
            }
            .adsense-preview
              .adsense-wrapper
              .adsense-pagination
              .adsense-pagination-item {
              margin: 9px 0;
              padding: 2px 2px;
              border: 1px solid rgba(0, 0, 0, 0.1);
            }
            .adsense-preview .adsense-wrapper .adsense-detail {
              padding: 5px;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .adsense-preview .adsense-wrapper .adsense-detail .left-icon,
            .adsense-preview .adsense-wrapper .adsense-detail .right-icon {
              width: 50px;
              font-size: 40px;
              margin: 0 15px;
              color: #ffa823;
              cursor: pointer;
              display: inline-block;
              user-select: none;
            }
            .adsense-preview
              .adsense-wrapper
              .adsense-detail
              .adsense-container {
              justify-content: center;
              display: flex;
              flex-direction: column;
            }
            @media only screen and (max-width: 990px) {
              .adsense-preview
                .adsense-wrapper
                .adsense-detail
                .adsense-pagination {
                display: none;
              }
            }

            @media only screen and (max-width: 990px) {
              .adsense-preview .adsense-wrapper {
                padding: 0;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

AdsensePreview.propTypes = {
  images: PropTypes.array,
};

AdsensePreview.defaultProps = {
  images: [
    {
      path:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_1_w.jpeg',
      thumbnail:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_1_t.jpeg',
    },
    {
      path:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_2_w.jpeg',
      thumbnail:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_2_t.jpeg',
    },
    {
      path:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_3_w.jpeg',
      thumbnail:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_3_t.jpeg',
    },
    {
      path:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_4_w.jpeg',
      thumbnail:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_4_t.jpeg',
    },
    {
      path:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_5_w.jpeg',
      thumbnail:
        'https://data.designac.co/data/thumbnails/d1/d16e6f5b0a3cb3fc6871608d18d04831_5_t.jpeg',
    },
  ],
};

export default AdsensePreview;
